module.exports = new __parcel__URL__("air_quality_and_covid19.638985da.png").toString();